import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { motion, AnimatePresence } from 'framer-motion';

/* Icons */
import ArrowIcon from '~/../symbols/arrow.svg';

/* Common */
import { Icon } from '~/components/common';

/* Constants */
import { scaleOutIn } from '~/constants/animations'

export default function Button({
   className = '',
   btnWrapperClassname = '',
   theme,
   href,
   showTitle = true,
   title,
   textClassName = '',
   target,
   attributes,
   showIcon = false,
   icon = ArrowIcon,
   iconClassName = '',
   iconType,
   iconTheme,
   iconSize = 20,
   onClick,
   loading = false,
   loadingSize = iconSize,
   loadingTheme,
                               }) {
    const Tag = href ? 'a' : 'button';
    const linkAttributes = href ? { href, target, rel: target == '_blank' ? 'noreferrer noopener' : '' } : {};

    return (
        <Tag
            className={`btn ${theme && `btn-${theme}`} ${className}`}
            {...linkAttributes}
            {...attributes}
            {...{ title, onClick }}
        >
            {showIcon && (
                <AnimatePresence initial={false} exitBeforeEnter>
                    {loading ?
                        (
                            <motion.div key="loading" {...scaleOutIn} className={`btn__icon-wrapper ${loadingSize ? `loading--${loadingSize}` : ''}`}>
                                <CircularProgress
                                    classes={{
                                        root: `loading loading--circular ${loadingSize ? `loading--${loadingSize}` : ''} ${loadingTheme ? `text-${loadingTheme}` : ''}`,
                                    }}
                                />
                            </motion.div>
                        )
                        :
                        (
                            <motion.div key="icon" {...scaleOutIn} className={`btn__icon-wrapper ${btnWrapperClassname}`}>
                                <Icon
                                    type={iconType}
                                    theme={iconTheme}
                                    size={iconSize}
                                    className={`btn__icon ${iconClassName}`}
                                    url={icon?.url}
                                />
                            </motion.div>
                        )
                    }
                </AnimatePresence>
            )}
            {showTitle && title && (
                <span className={`btn__text ${textClassName}`}>{title}</span>
            )}
        </Tag>
    );
}
